export function getModulePermissions(moduleName) {
  const storedPermissions = JSON.parse(
    localStorage.getItem("permissions") || "[]"
  );

  const userRole = localStorage.getItem("user_role") || "";

  // Roles that should be restricted by permissions (editable list if needed)
  const ROLES_WITH_PERMISSIONS = ["support_admin", "content_moderator", "customer_support"];

  const shouldCheckPermissions = ROLES_WITH_PERMISSIONS.includes(userRole);

  // If role is super admin (not restricted), allow everything
  if (!shouldCheckPermissions) {
    return {
      shouldCheckPermissions,
      canView: true,
      canAdd: true,
      canEdit: true,
      canDelete: true,
      canReview: true,
    };
  }

  // Otherwise check the stored permissions for this module
  const modulePerms = storedPermissions.find(
    (perm) => perm.moduleName === moduleName
  );

  return {
    shouldCheckPermissions,
    canView: modulePerms?.view || false,
    canAdd: modulePerms?.add || false,
    canEdit: modulePerms?.edit || false,
    canDelete: modulePerms?.delete || false,
    canReview: modulePerms?.review || false,
  };
}
